import { render } from "./Projects.vue?vue&type=template&id=f24aea42&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=f24aea42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f24aea42"

export default script